/**
 * Cross-cutting string constants shared by api/ and web/.
 * SCREAMING_SNAKE per engineering contract.
 */
/**
 * Postgres session variable that carries the current tenant for RLS.
 * The tenant-context middleware issues `SET LOCAL app.current_tenant = '<uuid>'`
 * per request; RLS policies read it via the `app.current_tenant_id()` helper.
 */
export const SESSION_TENANT_VAR = 'app.current_tenant';
/**
 * Default JWT claim that identifies the tenant on an incoming bearer token.
 *
 * This is a plain constant — it does NOT read `process.env` (which would run at
 * module load, escape ConfigService validation, and leak into the web bundle).
 * The API overrides it via `TENANT_CLAIM` in its validated env config; the web
 * side never needs the override.
 */
export const DEFAULT_TENANT_CLAIM = 'tid';
/** HTTP header carrying the bearer token (lower-case, as normalized by Node/Nest). */
export const AUTH_HEADER = 'authorization';
/** Scheme prefix (including trailing space) preceding a JWT in the auth header. */
export const BEARER_PREFIX = 'Bearer ';
/** Static SPA endpoint used by the version-check banner to detect new deploys. */
export const VERSION_ENDPOINT = '/version.json';
//# sourceMappingURL=constants.js.map